import React from 'react';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import { css } from '@emotion/react';
import { OnwardSwitch } from '@/styles/blocks';

// Drafted like the rest of the panel and written on Save.
const RegionSettings = ({ values, onChange, locations, disabled }) => {
    return (
        <Grid
            container
            direction="column"
            css={css`
                flex-wrap: nowrap;
                gap: 8px;
                padding: 12px 16px;
            `}
        >
            <OnwardSwitch
                label={'Resource Zone'}
                checked={!!values.is_resource_zone}
                onChange={(_, checked) => onChange('is_resource_zone', checked)}
                disabled={disabled}
            />
            <OnwardSwitch
                label={'Pricing Zone'}
                checked={!!values.is_pricing_zone}
                onChange={(_, checked) => onChange('is_pricing_zone', checked)}
                disabled={disabled}
            />
            <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                label="Receiving Warehouse"
                value={values.warehouse_id || 'DEFAULT'}
                disabled={disabled}
                css={css`
                    margin-top: 4px;
                `}
                onChange={(e) => onChange('warehouse_id', e.target.value === 'DEFAULT' ? null : e.target.value)}
            >
                <MenuItem key="DEFAULT" value={'DEFAULT'}>
                    Default (Preferred Inbound)
                </MenuItem>
                {(locations || []).map((location, i) => (
                    <MenuItem key={location.location_id} value={location.location_id}>
                        {location.location_name || `Warehouse ${i + 1}`}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    );
};

export default RegionSettings;
